import { getQuery, execQuery, luaScript } from '../../helpers/helper_store';

const state = {
	selectedTemplate: null,
	cronTemplates: null,
	currentTemplates: null,
	templateInfo: null,
	templateTasks: null,
	packetableTaskList: null,
	templateFlag: false,
	tasksFlag: false
};

const mutations = {
	setTemplate: (state, data) => (state.selectedTemplate = data),
	setTemplateName: (state, data) => (state.selectedTemplate.name = data),
	setCronTemplates: (state, data) => (state.cronTemplates = Array.isArray(data) ? data : [data]),
	setCurrentTemplates: (state, data) => (state.currentTemplates = Array.isArray(data) ? data : [data]),
	setPacketableTaskList: (state, data) => (state.packetableTaskList = Array.isArray(data) ? data : [data]),
	setTemplateInfo: (state, data) => (state.templateInfo = data),
	// setTemplateSectionId: (state, data) => {
	// 	if (state.templateInfo) state.templateInfo.idSection = data;
	// },
	setTemplateFlag: (state, data) => (state.templateFlag = data),
	setTasksFlag: (state, data) => (state.tasksFlag = data),
	setCronTemplateTasks: (state, data) => (state.templateTasks = Array.isArray(data) ? data : [data])
};

const actions = {
	getCronTemplatesList({ rootState, commit }) {
		return new Promise((resolve, reject) => {
			luaScript('croneditor', 'readTemplates', null, rootState.login)
				// getQuery('getCronTemplatesList', null, rootState.login)
				.then((result) => {
					// console.log(result);
					commit('setCronTemplates', result);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	getCronTemplateTasks({ rootState, commit }, idTemplate) {
		return new Promise((resolve, reject) => {
			getQuery('getCronTemplateTasks', [idTemplate], rootState.login)
				.then((result) => {
					commit('setCronTemplateTasks', result);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	getCronTemplates({ rootState, commit }) {
		return new Promise((resolve, reject) => {
			getQuery('getCronTemplates', null, rootState.login)
				.then((result) => {
					commit('setCurrentTemplates', result);
					resolve(Array.isArray(result) ? result : [result]);
				})
				.catch(() => {
					reject();
				});
		});
	},
	insCronTemplate({ rootState, dispatch }, name) {
		return new Promise((resolve, reject) => {
			execQuery('insCronTemplate', [name], rootState.login)
				.then(() => {
					return dispatch('getCronTemplatesList');
				})
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	updCronTemplateName({ rootState, commit, dispatch }, { name, id }) {
		return new Promise((resolve, reject) => {
			execQuery('updCronTemplate', [id, name], rootState.login)
				.then(() => {
					return dispatch('getCronTemplatesList');
				})
				.then(() => {
					return dispatch('getCronPackets');
				})
				.then(() => {
					commit("setTemplateName", name);
					resolve();
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	updCronTemplateTasks({ rootState, dispatch }, template) {
		return new Promise((resolve, reject) => {
			luaScript('croneditor', 'saveTemplate', template, rootState.login)
				.then(() => {
					return dispatch('getCronTemplatesList');
				})
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	updateTemplateSchedule({ rootState, dispatch }, { templateName, status }) {
		let savedResult = null;
		return new Promise((resolve, reject) => {
			luaScript('cronmaker', 'package_switcher', { template: templateName, enable: status, cron: rootState.cron.cron.id }, rootState.login)
				.then((result) => {
					savedResult = result;
					if (result.modify === 0) {
						throw new Error("Modify===0");
					}
					return dispatch('getCron');
				})
				.then(() => {
					return dispatch("getCronPackets");
				})
				.then(() => {
					resolve(savedResult);
				})
				.catch((err) => {
					if (err.message === "Modify===0") resolve(savedResult);
					console.error(err);
					reject(err);
				})
		})

	},
	delCronTemplate({ rootState, dispatch }, idTemplate) {
		return new Promise((resolve, reject) => {
			luaScript('croneditor', 'deleteTemplate', { idTemplate }, rootState.login)
				.then(() => {
					return dispatch('getCronTemplatesList');
				})
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	copyCronTemplate({ rootState, dispatch }, { name, id }) {
		return new Promise((resolve, reject) => {
			luaScript('croneditor', 'copyTemplate', { templateId: id, templateName: name }, rootState.login).then(() => {
				return dispatch("getCronTemplatesList");
			}).then(() => {
				resolve();
			}).catch((err) => {
				reject(err);
			})
		})
	},
	getTemplateInfo({ rootState, commit }, idTemplate) {
		return new Promise((resolve, reject) => {
			luaScript('croneditor', 'readTemplate', { idTemplate }, rootState.login)
				.then((result) => {
					commit('setTemplateInfo', result[0]);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	getPacketableTasks({ rootState, commit }) {
		return new Promise((resolve, reject) => {
			getQuery('getPTasks', null, rootState.login)
				.then((result) => {
					commit('setPacketableTaskList', result);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	}
};

const getters = {
	selectedTemplate: (state) => state.selectedTemplate,
	packetableTaskList: (state) => state.packetableTaskList,
	cronTemplates: (state) => state.cronTemplates,
	templateInfo: (state) => state.templateInfo,
	cronCurrentTemplates: (state) => state.cronCurrentTemplates,
	templateFlag: (state) => state.templateFlag,
	templateTasks: (state) => state.templateTasks,
	tasksFlag: (state) => state.tasksFlag
};

export default {
	state,
	mutations,
	actions,
	getters
};
